import { PaymentSummary, ReturnTransaction } from './transactionTypes';
import { getDefaultPaymentMethod } from './paymentMethodUtils';

export const processReturnTransaction = (
  returnTx: ReturnTransaction,
  summariesMap: Map<string, PaymentSummary>
): void => {
  console.log("Processing return transaction:", returnTx);

  if (returnTx.refund_amount && returnTx.refund_payment_method) {
    const method = getDefaultPaymentMethod(returnTx.refund_payment_method);
    const existing = summariesMap.get(method) || { 
      method, 
      amount: 0, 
      transactions: [],
      isValidated: false
    };
    
    // Convertir le montant de remboursement en nombre négatif pour le déduire
    const refundAmount = typeof returnTx.refund_amount === 'number' 
      ? -returnTx.refund_amount 
      : -parseFloat(returnTx.refund_amount);

    if (isNaN(refundAmount)) {
      console.error("Invalid refund amount:", returnTx.refund_amount);
      return;
    }

    existing.amount += refundAmount;

    if (existing.transactions) {
      console.log("Adding return transaction to list:", {
        id: returnTx.id,
        date: returnTx.created_at,
        amount: refundAmount,
        type: "return_refund"
      });

      existing.transactions.push({
        id: `${returnTx.id}-refund`,
        date: returnTx.created_at,
        amount: refundAmount,
        type: "return_refund",
        notes: `Remboursement retour produit`
      });
      
      existing.transactions.sort((a, b) => 
        new Date(b.date).getTime() - new Date(a.date).getTime()
      );
    }
    
    console.log("Updated summary for method:", method, existing);
    summariesMap.set(method, existing);
  }
};